{
  "v10.primitives.liste_non_visible": "List not visible for this profile.",
  "v10.primitives.non_visible": "Not visible for this profile.",
  "v10.primitives.refus.titre": "Access denied",
  "v10.primitives.regle_indisponible": "The access rule is unavailable.",
  "v10.primitives.assemblage.chargement": "Loading access rules…",
  "v10.primitives.assemblage.erreur": "Access rules could not be loaded."
}
